<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!fieldsets.newGroup1.hidden && !fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-newField1" *ngIf="!fields.newField1.hidden && !fields.newField1.removed" 
                            class="field-container standard {{fields.newField1.invalid ? 'invalid' : ''}} {{fields.newField1.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.newField1.styles.style"
                            [ngClass]="fields.newField1.styles.classes">
                        <div *ngIf="fields.newField1.label" class="label-container"
                             [matTooltip]="fields.newField1.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.newField1.label}}<span *ngIf="fields.newField1.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <button mat-button
                                data-cy="button"
                                class="datex-button"
                                [disabled]="fields.newField1.control.readOnly || fields.newField1.control.disabled"
                                [ngStyle]="fields.newField1.control.styles.style"
                                [ngClass]="fields.newField1.control.styles.classes"
                                [matTooltip]="fields.newField1.control.tooltip"
                                (click)="test($event)"
                                >
                          <div class="button-label">
                            <ng-container *ngIf="fields.newField1.control.icon === 'datex-default-spinner'; else showIcon">
                              <div class="button-icon">
                                <i data-cy="button-icon" class="datex-default-spinner"></i>
                              </div>
                            </ng-container>
                            <ng-template #showIcon>
                              <div class="button-icon">
                                <i data-cy="button-icon" class="icon {{fields.newField1.control.icon}}"></i>
                              </div>
                            </ng-template>
                            <div data-cy="button-label" class="button-text">{{fields.newField1.control.label}}</div>
                          </div>
                        
                        </button>
                        <ng-container *ngIf="fields.newField1.invalid">
                          <ng-container *ngFor="let error of fields.newField1.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>